// src/components/CandidateSidebar.js
import React from 'react';
import { Card,Grid,Avatar, CardContent, Typography, List, ListItem, ListItemText } from '@mui/material';

const LeftSidebar = () => {
    return (
        <Card sx={{ marginBottom: '20px' }}>
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <Avatar src="https://via.placeholder.com/60" sx={{ width: 60, height: 60 }} />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">张三</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Company
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                东京 前端开发工程师
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* <Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
                    个人简介摘要内容，可以简短描述一下自己...
                </Typography> */}
                </CardContent>
            </Card>
            <Card sx={{ position: 'sticky', top: 20 }}>
                <CardContent>
                    <List>
                        <ListItem button>
                            <ListItemText primary="我的资料" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="我的关注（29）" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="关注我的（238919）" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="隐私设置" />
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
        </Card>
    );
};

export default LeftSidebar;